import * as React from "react";

import type { IconProps } from "./types";

export const ZapIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path d="M7.99946 11.1818H2.99951L9.99944 1V6.81818H14.9994L7.99946 17V11.1818Z" fill={color} />
    </svg>
  ),
);

ZapIcon.displayName = "ZapIcon";

export default ZapIcon;
